import * as XLSX from "xlsx";

// Function to prepare data to export summary report
const prepareExcelDataForNCReport = (data) => {
  const excelRows = [];

  let srNo = 1;
  data.forEach((audit) => {
    // Add parent row (Audit summary)
    excelRows.push({
      "Audit No": srNo,
      "Audit Id": audit.auditId,
      "Audit Type": audit.auditTypeName,
      "Status": audit.status,
      "Total Activities": audit.totalActivities,
      "Confirmed Activities": audit.confirmedActivities,
      "Total NC's": audit.ncOrAOIActivities,
      "Open Activities": audit.openActivities,
      "Closed Activities": audit.closedActivities,
      "Branch Name": audit.branchName,
      "Department Name": audit.departmentName,
      "Area Name": audit.areaName,
      "Created By": audit.createdByName,
      "Auditor Name": audit.auditorName,
      "Auditee Name": audit.auditeeName,
      "Start Date": audit.readableStartDate,
      "End Date": audit.readableEndDate,
      "Created On": audit.createdAtForExcel,
      "Updated On": audit.updatedAtForExcel,
      "NC No": "",
      "Activity Name": "",
      "Progress Status": "",
      "Observation By Auditor": "",
      "CAPA": "",
      "Audit Point Status": "",
      "Remarks By Auditee": "",
      "Target Date": "",
    });

    // Add each NC Activity row below the parent
    (audit.activityList || []).forEach((activity, idx) => {
      excelRows.push({
        "Audit Id": "", // Optionally link to parent
        "Audit Type": "",
        "Status": "",
        "Total Activities": "",
        "Confirmed Activities": "",
        "Total NC's": "",
        "Open Activities": "",
        "Closed Activities": "",
        "Branch Name": "",
        "Department Name": "",
        "Area Name": "",
        "Created By": "",
        "Auditor Name": "",
        "Auditee Name": "",
        "Start Date": "",
        "End Date": "",
        "Created On": "",
        "Updated On": "",
        "NC No": idx + 1,
        "Activity Name": activity.name,
        "Progress Status": activity.complianceStatus,
        "Observation By Auditor": activity.auditorObservation,
        "CAPA": activity.capa,
        "Audit Point Status": activity.verificationStatus,
        "Remarks By Auditee": activity.remark,
        "Target Date": activity.targetDate,
      });
    });

    srNo++;
  });

  return excelRows;
};

// Export Summary Report data to excel
export const exportNcReportDataToExcel = (data) => {
  const preparedData = prepareExcelDataForNCReport(data);
  // Remove __rowType before export (optional)
  const cleanedData = preparedData.map(({ __rowType, ...row }) => row);
  const worksheet = XLSX.utils.json_to_sheet(cleanedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data Sheet");

  // Download the file
  XLSX.writeFile(workbook, `NC_Report_${new Date().getTime()}.xlsx`);
};